<div class="admin-editor-container">
    <!-- Spinner while catalog is being loaded -->
    <div *ngIf="loading && !loadError" class="pd-loader">
        <hc-progress-spinner color="purple" [diameter]="75"></hc-progress-spinner>
    </div>

    <!-- Error loading content -->
    <div *ngIf="!loading && loadError" class="pd-permission-error">
        <hc-icon fontSet="fa" fontIcon="fa-warning"></hc-icon>
        There was an error loading the 3rd Party item. Click below try again.
        <button hc-button size="lg" (click)="loadPartner()">Reload 3<sup>rd</sup> Party Item</button>
    </div>

    <div class="pd-admin-editor-page" [hidden]="loadError || loading">
        <ol class="breadcrumb pd-admin-editor-breadcrumbs">
            <li class="breadcrumb-item">
                <a routerLink="/admin/partners">3<sup>rd</sup> Party</a>
                <i class="fa fa-chevron-right breadcrumb-arrow"></i>
            </li>
            <li class="breadcrumb-item">
                <span>{{ partnerID ? partnerForm.controls['nameControl'].value + ' (#' + itemID + ')' : 'New 3rd Party' }} </span>
                <i class="fa fa-chevron-right breadcrumb-arrow"></i>
            </li>
        </ol>
        <h2>
            <hc-icon fontSet="fa" [fontIcon]="partnerID ? 'fa-pencil' : 'fa-plus'"></hc-icon>
            {{ partnerID ? 'Edit' : 'Add ' }} 3<sup>rd</sup> Party
        </h2>

        <div>
            <hc-tab-set direction="horizontal" [addContentContainer]="false" (selectedTabChange)="tabClick($event)"
                *ngIf="partner !== undefined">
                <hc-tab tabTitle="Editor"></hc-tab>
                <hc-tab tabTitle="Change Log"></hc-tab>
            </hc-tab-set>
            <div class="pd-admin-editor-container">
                <!-- EDITOR TAB CONTENT -->
                <div [formGroup]="partnerForm" [hidden]="selectedTab !== 0">
                    <div class="pd-admin-editor-actions-bar">
                        <hc-slide-toggle sideLabel="Published:" insideLabel="yes"
                            formControlName="published"></hc-slide-toggle>
                        <div class="pd-admin-editor-action-buttons">
                            <em *ngIf="partnerInputsDirty">unsaved changes</em>
                            <button hc-button buttonStyle="primary" class="save-button"
                                [disabled]="!partnerInputsDirty || !partnerForm.valid"
                                (click)="checkID(imageUploadModal)">
                                Save
                            </button>
                            <hc-split-button buttonStyle="primary-alt" (click)="openPdf()">
                                View
                                <button hcMenuItem>
                                    <span hcMenuText (click)="generateLink()">
                                        <span hcMenuIcon class="fa fa-copy fa-solid"></span>Copy PDF URL</span>
                                </button>
                            </hc-split-button>
                        </div>
                    </div>
                    <div class="pd-admin-editor-form">
                        <div class="edit-fields" [class.edit-form]="itemID !== undefined">
                            <hc-scroll-nav-content [nav]="ScrollNav" [makeLastTargetFullHeight]="true" #NavContent>
                                <section id="a1" hcScrollTarget>
                                    <div hcTileHeader>Identifying Information</div>
                                    <hc-form-field>
                                        <hc-label>Name:</hc-label>
                                        <input hcInput formControlName="nameControl" placeholder="Enter name"
                                            [required]="true" />
                                        <hc-error>A name is required</hc-error>
                                    </hc-form-field>
                                    <ng-container formArrayName="previousNamesControl"
                                    *ngFor="let prevName of this.partnerForm.controls.previousNamesControl.controls; index as i">
                                    <div class="prev-name-form-field-container">
                                        <hc-form-field>
                                            <hc-label>Previous Name {{ i + 1 }}:</hc-label>
                                            <input hcInput [formControlName]="i" placeholder="Enter a previous name" />
                                        </hc-form-field>
                                        <button hc-button title="Minimal Button" buttonStyle="minimal"
                                            hcTooltip="Remove previous name"
                                            *ngIf="partnerForm.controls.previousNamesControl.controls.length > 1"
                                            (click)="removePrevName(i)">
                                            <hc-icon fontSet="fa" fontIcon="fa-trash" class="icon-left"></hc-icon>
                                        </button>
                                    </div>
                                </ng-container>
                                <button hc-button buttonStyle="link" id="add-prev-name-button"
                                    (click)="addPrevName()">+ Add
                                    Another Name</button>
                                    <hc-form-field>
                                        <hc-label>Item Number:</hc-label>
                                        <input hcInput formControlName="IDControl" placeholder="Enter item number"
                                            type="number" [required]="true" (blur)="checkID()" />
                                        <hc-error>An unique item number is required</hc-error>
                                    </hc-form-field>
                                    <hc-form-field>
                                        <hc-label>Short Description (max 100 chars):</hc-label>
                                        <hc-label-ext>Used in Ignite UI</hc-label-ext>
                                        <input hcInput formControlName="shortDescription" placeholder="Enter short description" maxlength="100"/>
                                    </hc-form-field>
                                    <hc-form-field>
                                        <hc-label>Subtitle:</hc-label>
                                        <hc-label-ext>Used in Ignite UI</hc-label-ext>
                                        <input hcInput formControlName="subtitle" placeholder="Enter subtitle" maxlength="255"/>
                                    </hc-form-field>
                                    <hc-form-field>
                                        <hc-label>Solution Area:</hc-label>
                                        <hc-select formControlName="solutionArea" placeholder="Select solution area">
                                            <option [ngValue]="1">Data & Analytics</option>
                                            <option [ngValue]="2">Clinical Quality</option>
                                            <option [ngValue]="3">Revenue & Cost</option>
                                            <option [ngValue]="4">Population Health & Value-Based Care</option>
                                            <option [ngValue]="5">Regulatory & Cybersecurity</option>
                                        </hc-select>
                                    </hc-form-field>
                                    <hc-form-field>
                                        <hc-label>Status:</hc-label>
                                        <hc-select formControlName="statusControl" placeholder="Select status" [placeholderValue]="null"  [required]="true">
                                            <option *ngFor="let status of statuses" [ngValue]="status.statusID">{{
                                                status.name }}</option>
                                        </hc-select>
                                        <hc-error>A status is required</hc-error>
                                    </hc-form-field>
                                    <hc-label>Revision Date:</hc-label>
                                    <div id="revision-date"> {{ (this.revisionDate ? this.revisionDate : '') | date: 'fullDate' }}  {{ !this.revisionDate ? '--' : ''}}</div>
                                </section>
                                <section id="a2" hcScrollTarget>
                                    <div hcTileHeader>Tagline</div>
                                    <quill-editor class="content-editor" formControlName="taglineControl"
                                        placeholder="Enter tagline" [modules]="quillConfig"
                                        [styles]="quillStyles"></quill-editor>
                                </section>
                                <section id="a3" hcScrollTarget>
                                    <div hcTileHeader>Problem</div>
                                    <quill-editor class="content-editor" formControlName="problemControl"
                                        placeholder="Enter problem" [modules]="quillConfig"
                                        [styles]="quillStyles"></quill-editor>
                                </section>
                                <section id="a4" hcScrollTarget>
                                    <div hcTileHeader>Approach</div>
                                    <quill-editor class="content-editor" formControlName="approachControl"
                                        placeholder="Enter approach" [modules]="quillConfig"
                                        [styles]="quillStyles"></quill-editor>
                                </section>
                                <section id="a5" hcScrollTarget>
                                    <div hcTileHeader>Benefits and Features</div>
                                    <quill-editor class="content-editor" formControlName="benefitsFeaturesControl"
                                        placeholder="Enter benefits and features" [modules]="quillConfig"
                                        [styles]="quillStyles"></quill-editor>
                                </section>
                                <section id="a6" hcScrollTarget>
                                    <div hcTileHeader>Images</div>
                                    <hc-form-field *ngIf="images.length === 0">
                                        <hc-label>Select images to upload:</hc-label>
                                        <hc-file-uploader [formControl]="selectedImageFiles" [multiple]="true"
                                            fileTypes="image/png, image/jpeg, image/jpg"
                                            (filesAdded)="addImages()"></hc-file-uploader>
                                        <hc-error>Only image files are supported.</hc-error>
                                    </hc-form-field>
                                    <div *ngIf="images.length > 0">
                                        <form [formGroup]="imageForm">
                                            <table class="hc-table image-table">
                                                <thead>
                                                    <tr>
                                                        <th>File Name</th>
                                                        <th>Placement</th>
                                                        <th>Caption</th>
                                                        <th></th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr *ngFor="let img of images; index as i">
                                                        <td *ngIf="img.uploadID">
                                                            <a (click)="openLightbox(img)" class="open-img-link">{{
                                                                img.fileName }}</a>
                                                        </td>
                                                        <td *ngIf="!img.uploadID" class="image-name-max-width hc-text-ellipsis">{{ img.fileName }}</td>
                                                        <td>
                                                            <hc-select [formControlName]="'placement' + img.id" (change)="checkPlacement($event,i)">
                                                                <option>Body</option>
                                                                <option>Header</option>
                                                                <option>Footer</option>
                                                                <option>Hidden</option>
                                                            </hc-select>
                                                        </td>
                                                        <td>
                                                            <hc-form-field [inline]="true">
                                                                <textarea hcInput
                                                                    placeholder="Enter a caption for this image"
                                                                    [formControlName]="'caption' + img.id" rows="3"
                                                                    cols="30"></textarea>
                                                                <hc-error>Please add a caption for this
                                                                    image.</hc-error>
                                                            </hc-form-field>
                                                        </td>
                                                        <td>
                                                            <div class="hc-table-actions">
                                                                <span hcMenuIcon class="fa fa-trash hc-action-ico"
                                                                    hcTooltip="Remove image"
                                                                    (click)="confirmRemoveImage(img)"
                                                                    hcIconMd></span>
                                                            </div>
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </form>
                                        <hc-form-field [tight]="true">
                                            <hc-file-uploader #fileUploaderControl [formControl]="selectedImageFiles"
                                                [multiple]="true" fileTypes="image/png, image/jpeg, image/jpg"
                                                (filesAdded)="addImages()"></hc-file-uploader>
                                            <hc-error>Only image files are supported.</hc-error>
                                        </hc-form-field>
                                    </div>
                                </section>
                                <section id="a7" hcScrollTarget>
                                    <div hcTileHeader>Icons</div>
                                    <hc-form-field>
                                        <hc-label>SVG URL:</hc-label>
                                        <input hcInput formControlName="iconSVGControl" placeholder="Enter svg URL" />
                                    </hc-form-field>
                                    <hc-form-field>
                                        <hc-label>PNG URL:</hc-label>
                                        <input hcInput formControlName="iconPNGControl" placeholder="Enter png URL" />
                                    </hc-form-field>
                                    <hc-form-field>
                                        <hc-label>Base64 URL:</hc-label>
                                        <input hcInput formControlName="iconBase64Control"
                                            placeholder="Enter base64 URL" />
                                    </hc-form-field>
                                </section>
                                <section id="a8" hcScrollTarget>
                                    <div hcTileHeader>Technical Description</div>
                                    <quill-editor class="content-editor" formControlName="techDescControl"
                                        placeholder="Enter technical description" [modules]="quillConfig"
                                        [styles]="quillStyles"></quill-editor>
                                </section>
                            </hc-scroll-nav-content>
                        </div>
                        <div class="editor-nav">
                            <hc-scroll-nav #ScrollNav [scrollNavWithContent]="true">
                                <ul>
                                    <li hcScrollLink="a1">Identifying Information</li>
                                    <li hcScrollLink="a2">Tagline</li>
                                    <li hcScrollLink="a3">Problem</li>
                                    <li hcScrollLink="a4">Approach</li>
                                    <li hcScrollLink="a5">Benefits and Features</li>
                                    <li hcScrollLink="a6">Images</li>
                                    <li hcScrollLink="a7">Icons</li>
                                    <li hcScrollLink="a8">Technical Description</li>
                                </ul>
                            </hc-scroll-nav>
                        </div>
                    </div>
                </div>
            </div>
            <!-- CHANGE LOG TAB CONTENT -->
            <pd-admin-change-log #changeLog [hidden]="selectedTab !== 1"></pd-admin-change-log>

            <!-- MODALS -->
            <ng-template #imageUploadModal let-dismiss="dismiss" let-data="data">
                <hc-modal>
                    <hc-modal-header>Uploading Images</hc-modal-header>
                    <hc-modal-body>
                        <div *ngFor="let img of data.images" class="image-load-row">
                            <div class="image-load-row-icon">
                                <hc-icon *ngIf="img.uploadState === 0" fontSet="fa" fontIcon="fa-clock-o"
                                    class="waiting-icon" hcIconLg></hc-icon>
                                <div *ngIf="img.uploadState === 1">
                                    <hc-progress-dots color="dark" [isMini]="true"></hc-progress-dots>
                                </div>
                                <hc-icon *ngIf="img.uploadState === 2" fontSet="fa" fontIcon="fa-check-circle"
                                    class="success-icon" hcIconLg></hc-icon>
                                <hc-icon *ngIf="img.uploadState === -1" fontSet="fa" fontIcon="fa-times-circle"
                                    class="error-icon" hcIconLg></hc-icon>
                            </div>
                            <div class="image-load-row-info">
                                <strong>{{ img.fileName }}</strong>
                                <div *ngIf="img.uploadState === 0">Waiting to upload</div>
                                <div *ngIf="img.uploadState === 1">Uploading...</div>
                                <div *ngIf="img.uploadState === 2">Successfully uploaded</div>
                                <div *ngIf="img.uploadState === -1">Unable to upload</div>
                            </div>
                        </div>
                    </hc-modal-body>
                    <hc-modal-footer>
                        <button hc-button (click)="savePartner(); this.modalRef.dismiss()">Continue</button>
                    </hc-modal-footer>
                </hc-modal>
            </ng-template>
        </div>
    </div>
</div>